var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003FD1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6634128,2 C7.23174709,2 2,7.23658721 2,13.6699215 L2,30.3365872 C2,36.7682529 7.23658721,42 13.6699215,42 L30.3365872,42 C36.7682529,42 42,36.7634128 42,30.3300785 L42,13.6634128 C42,7.23174709 36.7634128,2 30.3300785,2 L13.6634128,2 Z M33.6666657,8.6666657 C34.5866657,8.6666657 35.3333314,9.4133314 35.3333314,10.3333314 C35.3333314,11.2533314 34.5866657,11.9999971 33.6666657,11.9999971 C32.7466657,11.9999971 32,11.2533314 32,10.3333314 C32,9.4133314 32.7466657,8.6666657 33.6666657,8.6666657 Z M22,12 C27.515,12 32,16.485 32,22 C32,27.515 27.515,32 22,32 C16.485,32 12,27.515 12,22 C12,16.485 16.485,12 22,12 Z M22,15.3333343 C18.3181017,15.3333343 15.3333343,18.3181017 15.3333343,22 C15.3333343,25.6818983 18.3181017,28.6666657 22,28.6666657 C25.6818983,28.6666657 28.6666657,25.6818983 28.6666657,22 C28.6666657,18.3181017 25.6818983,15.3333343 22,15.3333343 Z",
    id: "ic_instagram"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic_instagram.e3a7d66ca1893caefeb1337567a1904b.svg";
export { ForwardRef as ReactComponent };